import React, { FC, useMemo, useState } from 'react';
import { Button, Col, Input, Row, Table, TableProps, Typography } from 'antd';
import { SearchOutlined } from '@ant-design/icons';

import { GetRecoveryByUsernameResponseDto } from '@services/_api';

import { useRecoveryAccountContext } from './context';
import IAPInfoModal, { IAPInfo } from './iap-modal';

const { Text, Title } = Typography;

const FindByUsername: FC = () => {
  const {
    environment,
    username,
    setUsername,
    recoveryByUsername,
    isFetchingByUsername,
    handleGetRecoveryByUsername,
  } = useRecoveryAccountContext();
  const [iapInfoModalVisible, setIapInfoModalVisible] = useState(false);
  const [iapInfoModalData, setIapInfoModalData] = useState<IAPInfo[]>([]);

  const onCloseIapInfoModal = () => {
    setIapInfoModalVisible(false);
    setIapInfoModalData([]);
  };

  const openIapInfoModal = (data: IAPInfo[]) => {
    setIapInfoModalData(data);
    setIapInfoModalVisible(true);
  };
  const columns = useMemo<TableProps<GetRecoveryByUsernameResponseDto>['columns']>(
    () => [
      {
        title: 'User ID',
        dataIndex: 'Id',
        key: 'Id',
      },
      {
        title: 'Name',
        dataIndex: 'Name',
        key: 'Name',
      },
      {
        title: 'Clan ID',
        dataIndex: 'Clan_Id',
        key: 'Clan_Id',
      },
      {
        title: 'Clan Name',
        dataIndex: 'ClanName',
        key: 'ClanName',
      },
      {
        title: 'IAP Info',
        dataIndex: 'IAPInfo',
        key: 'IAPInfo',
        render: (value: IAPInfo[]) => {
          return (
            <Button type="link" onClick={() => openIapInfoModal(value)}>
              {value.length} Transactions
            </Button>
          );
        },
      },
    ],
    [],
  );
  return (
    <>
      <Title level={5} className="mr-2">
        Username
      </Title>
      <Row gutter={[16, 16]} className="mb-4">
        <Col>
          <Input.Group>
            <Input
              value={username}
              placeholder="Enter username"
              style={{ width: 250 }}
              onChange={(e) => setUsername(e.target.value)}
              onPressEnter={handleGetRecoveryByUsername}
            />
            <Button
              htmlType="submit"
              type="primary"
              onClick={handleGetRecoveryByUsername}
              disabled={!username || !environment}
            >
              <SearchOutlined />
            </Button>
          </Input.Group>
        </Col>
      </Row>
      <Table
        loading={isFetchingByUsername}
        scroll={{ y: 'calc(100vh - 400px)' }}
        dataSource={recoveryByUsername}
        columns={columns}
        rowKey="Id"
      />
      <IAPInfoModal
        data={iapInfoModalData}
        visible={iapInfoModalVisible}
        onOk={onCloseIapInfoModal}
        onCancel={onCloseIapInfoModal}
      />
    </>
  );
};

export default FindByUsername;
